<template>
  <div name="step1">
    <div class="noti-box top">
      {{
        exam.acceptIdCard
          ? $t(`preRegistration.step1.commentIdcard.${user.examIdType}`)
          : $t('preRegistration.step1.comment')
      }}
    </div>
    <StepBox :step="step" :exam="exam" />

    <!-- TODO: 정면 / 측면 / 화면 / 신분증 사용 조건 / 이벤트 사용 조건 아무 것도 없으면 준비사항 안내 false 처리 -->
    <i18n
      tag="h4"
      path="preRegistration.step1.preparationGuide"
      v-if="readyInfo">
      <template #guide>
        <span>{{ $t('preRegistration.step1.preparationCheck') }} </span>
      </template>
    </i18n>
    <div class="prereg-guide">
      <div class="card-box" v-if="exam.acceptIdCard">
        <div>
          <img src="@/assets/images/icon/ico_idcard.png" alt="" />
        </div>
        <div class="item-text">
          <strong>
            {{
              $t(
                `preRegistration.step1.preparation.idCard.${user.examIdType}.title`,
              )
            }}
          </strong>
          <p>
            {{
              $t(
                `preRegistration.step1.preparation.idCard.${user.examIdType}.label`,
              )
            }}
          </p>
        </div>
      </div>
      <div class="card-box" v-if="useFront">
        <div>
          <img src="@/assets/images/icon/ico_pc_front.png" alt="" />
        </div>
        <div class="item-text">
          <i18n
            tag="strong"
            path="preRegistration.step1.preparation.frontalMonitoringDevice.row1.title">
            <template #inner>
              <span>{{
                $t(
                  'preRegistration.step1.preparation.frontalMonitoringDevice.row1.inner',
                )
              }}</span>
            </template>
          </i18n>
          <p>
            {{
              $t(
                'preRegistration.step1.preparation.frontalMonitoringDevice.row2',
              )
            }}
          </p>
        </div>
      </div>
      <div class="card-box" v-if="exam.sideMonitoring">
        <div>
          <img src="@/assets/images/icon/ico_mo.png" alt="" />
        </div>
        <div class="item-text">
          <i18n
            tag="strong"
            path="preRegistration.step1.preparation.sideMonitoringDevice.row1.title">
            <template #inner>
              <span>{{
                $t(
                  'preRegistration.step1.preparation.sideMonitoringDevice.row1.inner',
                )
              }}</span>
            </template>
          </i18n>
          <p>
            {{
              $t('preRegistration.step1.preparation.sideMonitoringDevice.row2')
            }}
          </p>
        </div>
      </div>
    </div>
    <h4>{{ $t('preRegistration.step1.examEnvTestGuide.title') }}</h4>
    <h5>
      {{ $t('preRegistration.step1.examEnvTestGuide.chromeBrowser.title') }}
    </h5>
    <div class="card-box bg top">
      {{ $t('preRegistration.step1.examEnvTestGuide.chromeBrowser.row1') }}
      <div class="btn-box bottom-sm">
        <button
          type="button"
          class="btn btn-line-dark btn-sm icon icon-link"
          @click="downloadChrome">
          {{
            $t(
              'preRegistration.step1.examEnvTestGuide.chromeBrowser.downloadChrome',
            )
          }}
        </button>
      </div>
    </div>
    <h5>
      {{
        $t('preRegistration.step1.examEnvTestGuide.importanceOfTesting.title')
      }}
    </h5>

    <div class="card-box bg top">
      {{
        $t('preRegistration.step1.examEnvTestGuide.importanceOfTesting.row1')
      }}
      <br />
      {{
        $t('preRegistration.step1.examEnvTestGuide.importanceOfTesting.row2')
      }}
      <p class="strong-text">
        {{
          $t('preRegistration.step1.examEnvTestGuide.importanceOfTesting.row3')
        }}
      </p>
    </div>

    <i18n tag="h5" path="preRegistration.step1.examEnvTestGuide.cheating.title">
      <template #inner>
        <strong>{{
          $t('preRegistration.step1.examEnvTestGuide.cheating.comment')
        }}</strong>
      </template>
    </i18n>
    <div class="card-box bg top">
      <ol>
        <li>
          <span>1</span>
          {{
            exam.acceptIdCard
              ? $t(
                  `preRegistration.step1.cheatingAction.row1Idcard.${user.examIdType}`,
                )
              : $t('preRegistration.step1.cheatingAction.row1')
          }}
        </li>
        <li>
          <span>2</span
          >{{ $t('preRegistration.step1.cheatingAction.row2.text1') }}<br />{{
            $t('preRegistration.step1.cheatingAction.row2.text2')
          }}
        </li>
        <li>
          <span>3</span
          >{{ $t('preRegistration.step1.cheatingAction.row3.text1') }}<br />{{
            $t('preRegistration.step1.cheatingAction.row3.text2')
          }}
        </li>
        <li>
          <span>4</span>{{ $t('preRegistration.step1.cheatingAction.row4') }}
        </li>
      </ol>
    </div>

    <h5>{{ $t('preRegistration.step1.questions.title') }}</h5>
    <div class="card-box bg top">
      <i18n path="preRegistration.step1.questions.label">
        <template #contact>
          <br />
          <a :target="inquiryTarget" :href="inquiryLink">
            <u
              ><strong>{{ exam.contactLink }}</strong></u
            >
          </a>
        </template>
      </i18n>
    </div>
    <div class="card-box form-check-box">
      <div class="text">
        {{ $t('preRegistration.step1.agreement.row1') }}<br />
        {{ $t('preRegistration.step1.agreement.row2') }}
      </div>
      <div class="form-check form-check-lg">
        <input id="check-1" type="checkbox" v-model="agreement" />
        <label for="check-1"
          ><span>{{
            $t('preRegistration.step1.agreement.checkbox')
          }}</span></label
        >
      </div>
    </div>
  </div>
</template>

<script>
  import StepBox from '@/components/pre-registration/StepBox.vue';
  import {CHROME_DOWNLOAD_URL} from '@/js/common/constants';
  import inquiry from '@/mixins/inquiry';
  import stepMixin from '@/mixins/step';

  export default {
    name: 'Step1',
    mixins: [stepMixin, inquiry],
    components: {
      StepBox,
    },
    data() {
      return {
        agreementForExam: false,
      };
    },
    methods: {
      downloadChrome() {
        window.open(CHROME_DOWNLOAD_URL);
      },
    },
    computed: {
      agreement: {
        get() {
          return this.agreementForExam;
        },
        set(value) {
          this.agreementForExam = value;
          this.$nextTick(() => this.validated(value));
        },
      },

      exam() {
        return this.$store.getters['user/getExam'];
      },

      useFront() {
        return (
          this.exam.frontMonitoring ||
          this.exam.faceEvent ||
          this.exam.screenMonitoring
        );
      },

      readyInfo() {
        const {sideMonitoring, acceptIdCard} = this.exam;

        return this.useFront || sideMonitoring || acceptIdCard;
      },
    },
    activated() {
      document.querySelectorAll('.ps')[0].scrollTop = 0;
      if (this.stepNavigation.from > this.stepNavigation.to) {
        this.agreementForExam = true;
        this.validated(this.agreementForExam);
      }
      this.$nextTick(() => this.$emit('show-buttons', true));
    },
  };
</script>
